const ROLE_BY_PREFIX = [
  ["/super", "superadmin"],
  ["/admin", "school"],
  ["/parent", "parent"],
  ["/teacher", "teacher"],
  ["/pupil", "pupil"],
  ["/kid", "child"],
];

export function roleForPath(pathname) {
  for (const [prefix, role] of ROLE_BY_PREFIX) {
    if (pathname === prefix || pathname.startsWith(prefix + "/")) return role;
  }
  return null;
}

export function getToken(role = roleForPath(window.location.pathname)) {
  if (role) {
    const scoped = localStorage.getItem(`timely_token_${role}`);
    if (scoped) return scoped;
  }
  return localStorage.getItem("timely_token");
}

export function saveToken(role, token) {
  localStorage.setItem(`timely_token_${role}`, token);
  localStorage.removeItem("timely_token");
}

export function clearToken(role) {
  if (role) localStorage.removeItem(`timely_token_${role}`);
  localStorage.removeItem("timely_token");
}
